/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Doors_AdvanceInputs */



/**
* | output |
* | --- |
* | "Collected in advance, somewhere else" |
*
* @param {Tournament_Wiz_Doors_AdvanceInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_doors_advance = /** @type {((inputs?: Tournament_Wiz_Doors_AdvanceInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Doors_AdvanceInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encaissé à l'avance, ailleurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se cobra por adelantado, en otro sitio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cobrada com antecedência, em outro lugar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riscossa in anticipo, altrove")
	return /** @type {LocalizedString} */ ("Collected in advance, somewhere else")
});